import { FC } from 'react'

type SegmentedToggleProps = {
  value: boolean
  onChange: (_value: boolean) => void
  trueLabel?: string
  falseLabel?: string
}

export const SegmentedToggle: FC<SegmentedToggleProps> = ({
  value,
  onChange,
  trueLabel = 'Açık',
  falseLabel = 'Kapalı',
}) => {
  return (
    <div className="flex bg-surface-subtle p-1 rounded-xl border border-main shrink-0 w-[140px]">
      <button
        type="button"
        className={`flex-1 px-2 py-1.5 rounded-lg text-sm font-medium transition-colors ${
          value === false
            ? 'bg-main text-brand-secondary shadow-sm ring-1 ring-black/5 dark:ring-white/10'
            : 'text-muted hover:text-main'
        }`}
        onClick={() => onChange(false)}
      >
        {falseLabel}
      </button>
      <button
        type="button"
        className={`flex-1 px-2 py-1.5 rounded-lg text-sm font-medium transition-colors ${
          value === true
            ? 'bg-main text-brand-secondary shadow-sm ring-1 ring-black/5 dark:ring-white/10'
            : 'text-muted hover:text-main'
        }`}
        onClick={() => onChange(true)}
      >
        {trueLabel}
      </button>
    </div>
  )
}

export default SegmentedToggle
